// KpiCard — single KPI tile in the admin console.
//
// Displays a number with a sub-label and a soft tinted icon. If `trend` is
// provided, it shows below the number as a small accent. `loading` shows a
// shimmer placeholder so the layout doesn't jump.

import React from 'react';

export default function KpiCard({ icon, label, value, trend, tone = 'mist', loading = false }) {
  return (
    <div className={`dia-kpi dia-kpi-${tone}`}>
      <span className="dia-kpi-icon" aria-hidden="true">{icon}</span>
      <div className="dia-kpi-body">
        <span className={`dia-kpi-value${loading ? ' is-loading' : ''}`}>
          {loading ? '—' : value}
        </span>
        <span className="dia-kpi-label">{label}</span>
        {!loading && trend ? <span className="dia-kpi-trend">{trend}</span> : null}
      </div>
    </div>
  );
}
